
module.exports = (function ($, window, document, undefined) {
    "use strict";
    var self;

    // Create the defaults once
    var pluginName = "gpmPayerIsRemitter",
        defaults = {
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        self = this;
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            //Variables
            self.$el = $(this.element);
            self.FirstName = $('#FirstName');
            self.LastName = $('#LastName');
            self.Address1 = $('#Address1');
            self.City = $('#City');
            self.State = $('#State');
            self.Zip = $('#Zip');
            self.Country = $('#Country');
            self.Email = $('#Email');

            self.PayerIsRemitter = $('#PayerIsRemitter');

            self.RemitterName = $('#RemitterName');
            self.RemitterAddress1 = $('#RemitterAddress1');
            self.RemitterCity = $('#RemitterCity');
            self.RemitterState = $('#RemitterState');
            self.RemitterZip = $('#RemitterZip');
            self.RemitterCountry = $('#RemitterCountry');
            self.RemitterEmail = $('#RemitterEmail');

            //Bindings
            self.PayerIsRemitter.change($.proxy(self.getPayerDetailsToRemitter, self));
        },
        getPayerDetailsToRemitter: function () {
            if ($(self.PayerIsRemitter).is(":checked")) {
                $(self.RemitterName).val($(self.FirstName).val());
                if ($(self.LastName).val() != '') {
                    $(self.RemitterName).val(($(self.FirstName).val().substring(0, 10) + ' ' + $(self.LastName).val()).substring(0, 30));
                }

                $(self.RemitterAddress1).val($(self.Address1).val());
                $(self.RemitterCity).val($(self.City).val());
                $(self.RemitterState).val($(self.State).val());
                $(self.RemitterZip).val($(self.Zip).val());
                $(self.RemitterCountry).val($(self.Country).val()).trigger('change');
                $(self.RemitterEmail).val($(self.Email).val());
            }
            else {
                $(self.RemitterName).val('');
                $(self.RemitterAddress1).val('');
                $(self.RemitterCity).val('');
                $(self.RemitterState).val('');
                $(self.RemitterZip).val('');
                $(self.RemitterCountry).val('');
                $(self.RemitterEmail).val('');
            }
        },
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
